var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThreeDot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8.7C1.2.7.6 1.2.6 1.9c0 .6.5 1.2 1.2 1.2.6 0 1.2-.5 1.2-1.2C2.9 1.2 2.4.7 1.8.7zm4.3 0c-.6 0-1.2.5-1.2 1.2 0 .6.5 1.2 1.2 1.2.6 0 1.2-.5 1.2-1.2C7.2 1.2 6.7.7 6.1.7zm4.3 0c-.6 0-1.2.5-1.2 1.2 0 .6.5 1.2 1.2 1.2s1.2-.5 1.2-1.2c-.1-.7-.6-1.2-1.2-1.2z",
    fill: "#282934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDot);
export default __webpack_public_path__ + "static/media/icon-three-dot.bcfb237fcc2e35dfad70800d08c50a99.svg";
export { ForwardRef as ReactComponent };